<section class="content-header">
  <h1>
    <span i18n="@@capaLicenses">CAPA Licenses</span>
    <a (click)="rerender()" style="cursor: pointer; color: #6682b2; margin-left: 0.5%"><span class="fa fa-refresh"></span></a>
  </h1>
  <ol class="breadcrumb">
    <li><a><em class="fa fa-signal"></em> CAPA</a></li>
    <li class="active" i18n="@@Licenses">Licenses</li>
  </ol>
</section>
<section class="content">
  <div class="box box-capa">
    <div class="box-body">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered" aria-describedby="Capa client licenses list">
        <thead>
          <tr>
            <th id="licenselist-client-number" tabindex="0" i18n="@@clientNumber">Client number</th>
            <th id="licenselist-last-name" tabindex="1" i18n="@@lastname">Name</th>
            <th id="licenselist-activation-date" tabindex="2" i18n="@@activationDate">Activation date</th>
            <th id="licenselist-creation-date-time" tabindex="3" i18n="@@creationDateTime">Date and time of creation</th>
            <th id="licenselist-linked-base-amount" tabindex="4" i18n="@@linkedBaseAmount">Number of linked devices</th>
          </tr>
        </thead>

        <tbody *ngIf="allLicenses.length > 0; else loading">

          <tr  (click)="goToLicense(license)" *ngFor="let license of allLicenses" style="cursor: pointer;">
            <td> {{ license.numeroClient }} </td>
            <td> {{ license.nom }} </td>
            <td> {{ license.activation | date: 'dd/MM/yyy' }} </td>
            <td> {{ license.creeLe | date: 'dd/MM/yyyy' }} </td>
            <td> {{ license.nbBases }} </td>
          </tr>
        </tbody>
      </table>

      <ng-template #loading>
        <tbody align="center">
        <tr>
          <td colspan="5">
            <em class="fa fa-spin fa-refresh"></em>&nbsp;<span i18n="@@InProgress">In progress</span>
          </td>
        </tr>
        </tbody>
      </ng-template>

      <button class="btn btn-capa" style="float: right;" data-toggle="control-sidebar"><span class="fa fa-plus-circle" style="margin-right: 5px"></span> <span i18n="@@newInstall">New install</span></button>
    </div>
  </div>
</section>

<aside class="control-sidebar control-sidebar-dark">
  <div class="p-3">
    <app-license-sidebar (refreshEvent)="rerender()"></app-license-sidebar>
  </div>
</aside>
<div class="control-sidebar-bg"></div>
